import {autoserializeAs, inheritSerialization} from "dcerialize";
import type {Existing, IdentifiableModel, IdOf, New} from "../base/IdentifiableModel";
import {createExisting, createNew} from "../base/IdentifiableModel";
import type {ModificationTrackedModel} from "../base/ModificationTrackedModel";
import type {SoftDeletableModel} from "../base/SoftDeletableModel";
import {ModificationDetails} from "../ModificationDetails";

export class IdOnlyBactoforceArea implements IdentifiableModel {
  @autoserializeAs(() => Number)
  public id?: number;

  public static existing(id: IdOf<IdOnlyBactoforceArea>): Existing<IdOnlyBactoforceArea> {
    return createExisting(IdOnlyBactoforceArea, id);
  }
}

@inheritSerialization(() => IdOnlyBactoforceArea)
export class WritableBactoforceArea extends IdOnlyBactoforceArea {
  @autoserializeAs(() => String)
  public name: string;

  public static createNew(name: string): New<WritableBactoforceArea> {
    const area = createNew(WritableBactoforceArea);
    area.name = name;
    return area;
  }
}

@inheritSerialization(() => WritableBactoforceArea)
export class SimpleBactoforceArea extends WritableBactoforceArea implements SoftDeletableModel {
  @autoserializeAs(() => Boolean)
  public readonly isDeleted: boolean;
}

/**
 * @sealed
 */
@inheritSerialization(() => SimpleBactoforceArea)
export class BactoforceArea extends SimpleBactoforceArea implements ModificationTrackedModel {
  @autoserializeAs(() => ModificationDetails)
  public readonly modificationDetails?: ModificationDetails;
}
